export default __webpack_public_path__ + "static/media/fullscreen.2825c58a.svg";